import { PiralPlugin } from "piral-core";

export interface PiletLanguageApi {
  getLanguage: () => string;
}

export function createLanguageApi(language: string): PiralPlugin<PiletLanguageApi> {
  return (_context) =>
    (_api, _target): PiletLanguageApi => ({
      getLanguage: () => language
    });
}
